export default __webpack_public_path__ + "static/media/trustWallet-new.89016b7d.svg";